import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import DicomTagSelector from '../shared/DicomTagSelector'; // Adjust path as needed

const defaultOptions = {
  tags_to_pseudonymize: ['PatientName', 'PatientID', 'PatientBirthDate', 'SOPInstanceUID', 'StudyInstanceUID', 'SeriesInstanceUID'],
  save_to_db: false
};

const DicomProfileEditDialog = ({ open, onClose, onSave, initialData }) => {
  const { t } = useTranslation();

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [options, setOptions] = useState(defaultOptions);
  
  useEffect(() => {
    if (open) {
      if (initialData) {
        setName(initialData.name || '');
        setDescription(initialData.description || '');
        setOptions(initialData.options || defaultOptions);
      } else {
        setName('');
        setDescription('');
        setOptions(defaultOptions);
      }
    }
  }, [open, initialData]);

  const handleSave = () => {
    if (!name.trim()) return;
    onSave({ name, description, options });
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth 
      scroll="paper"
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ fontWeight: 600 }}>
        {initialData ? t('DicomProfileForm.editTitle', 'Upraviť DICOM Profil') : t('DicomProfileForm.createTitle', 'Nový DICOM Profil')}
      </DialogTitle>
      
      <DialogContent dividers sx={{ bgcolor: 'background.default' }}>
        <Stack spacing={2.5} sx={{ mb: 3 }}>
          <TextField
            label={t('common.name', 'Názov')}
            fullWidth
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            size="small"
            InputProps={{ sx: { borderRadius: 2 } }}
          />
          <TextField
            label={t('common.description', 'Popis')}
            fullWidth
            multiline
            rows={2}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            size="small"
            InputProps={{ sx: { borderRadius: 2 } }}
          />
        </Stack>

        {/* 🪄 Magic happens here */}
        <DicomTagSelector options={options} onChangeOptions={setOptions} />

      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={onClose}
          sx={{ fontWeight: 600, borderRadius: 2 }}
        >
          {t('common.cancel', 'Zrušiť')}
        </Button>
        <Button 
          variant="contained" 
          onClick={handleSave} 
          disabled={!name.trim()}
          disableElevation
          sx={{ fontWeight: 600, borderRadius: 2 }}
        >
          {t('common.save', 'Uložiť')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DicomProfileEditDialog;